export default __webpack_public_path__ + "static/media/grandfather.33ee8136.png";